import React, { useEffect, useState } from 'react'
import type { UploadRequestOption } from "rc-upload/lib/interface";

import {
    FileExcelFilled,
    FileExcelOutlined,
    RightCircleOutlined,
    UploadOutlined
} from '@ant-design/icons';

import {
    Steps,
    message,
    Form,
    Button,
    Input,
    Space,
    DatePicker,
    Row,
    Col,
    UploadFile,
    UploadProps,
    notification
} from 'antd';

import Dragger from 'antd/lib/upload/Dragger';
import { useSelector } from 'react-redux';
import { FormInstance, useForm } from 'antd/lib/form/Form';

import moment from 'moment';
import { useApi } from '../../../../Utils';

// <WarehouseInjectorPEDocuments rut='20506985308' rsocial='GRETA PERU SAC' endpoint='/inventario/mov' resetAll={resetAll} />
export default function WarehouseInjectorPEDocuments({ rut = '20506985308', rsocial = 'GRETA PERU SAC', endpoint = '', resetAll, postProcessing = false, setMainLoading, exampleFile, documento, setOptions }: any) {
    const [step,] = useState(0)
    const { token } = useSelector((state: any) => state)
    const [form] = useForm()
    const [data, setData] = useState<any>([])
    const [continueDisabled, setContinueDisabled] = useState<boolean>(true)

    const { data: data_inject, loading: loading_inject, fetch: inject, errors: errors_inject } = useApi<any>('post', endpoint, {
        requiredToken: true,
        onRequest: true
    })
        

    const continueButton = () => {
        // console.log(continueDisabled, continueButton)
        form.submit()
        // setStep(_s => _s + 1)
    }

    useEffect(() => {
        if (data && data?.date && data?.orders && data.orders.length > 0) {
            setMainLoading(true)
            console.log(data)
            inject({
                fechaMov: `${moment(data.date).format("YYYY-MM-DD")} 09:00:00.000`,
                filePath: data.orders[0].path,
                inject: `true`
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])

    useEffect(() => {
        if (data_inject?.success) {
            notification.success({
                message: `${data_inject.message}`,
                description: `Movimiento de Inventario: ${data_inject.data.folioMovInv}`,
                duration: 0,
                key: `NotificationSuccess${data_inject.data.folioMovInv}`
            })
            setMainLoading(false)
            resetAll()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data_inject])

    useEffect(() => {
        console.log(errors_inject)
    }, [errors_inject])

    useEffect(() => {
        setOptions(<>
            <div key="OptionsKeyLeft">
                {/* <Button type="text" disabled>
                    <FileExcelOutlined />
                    Exportar a Excel
                </Button> */}
                {/* <Button type="text">
                            <FileExcelOutlined />
                            Exportar a Excel
                        </Button> */}
            </div>
            <Button type="text" disabled={continueDisabled || loading_inject} onClick={continueButton} key="ContinuePEDocument" loading={loading_inject}>
                <RightCircleOutlined />
                Continuar
            </Button>
        </>)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [continueDisabled, loading_inject])

    const [fileList, setFileList] = React.useState<UploadFile<any>[]>([]);

    const makeCustomRequest = ({ token, endpoint, extra }: { token: string; endpoint: string; extra: Record<string, any> }) => async (options: UploadRequestOption) => {
        const { file, onProgress, onSuccess, onError } = options;

        try {
            const formData = new FormData();
            formData.append("file", file as Blob);
            // 👇 tu parámetro extra
            Object.entries(extra).forEach(([k, v]) => formData.append(k, String(v)));

            const xhr = new XMLHttpRequest();
            xhr.open("POST", `https://app.bodegaenlinea.cl/api/${endpoint}`);
            xhr.setRequestHeader("Authorization", `Bearer ${token}`);

            xhr.upload.onprogress = (evt) => {
                if (evt.total > 0) {
                    onProgress?.({ percent: (evt.loaded / evt.total) * 100 });
                }
            };

            xhr.onload = () => {
                // tu API devuelve JSON -> { status: 'success'|'error', ... }
                try {
                    const res = JSON.parse(xhr.responseText || "{}");
                    if (xhr.status >= 200 && xhr.status < 300) onSuccess?.(res, xhr as any);
                    else onError?.(res, xhr as any);
                } catch (e) {
                    // si no viene JSON
                    xhr.status >= 200 && xhr.status < 300
                        ? onSuccess?.(xhr.responseText as any, xhr as any)
                        : onError?.(new Error(xhr.responseText), xhr as any);
                }
            };

            xhr.onerror = () => onError?.(new Error("Network error") as any);

            xhr.send(formData);
        } catch (err) {
            onError?.(err as any);
        }
    };

    
    const createUploaderProps = (
        token: string,
        endpoint: string,
        form: FormInstance<any>,
        accept = '.xlsx',
        success?: (file: UploadFile<any>) => void,
        // postProcessing = false
    ): UploadProps => {
        // console.log(postProcessing)
        return {
            multiple: false,
            maxCount: 1,
            fileList,
            customRequest: makeCustomRequest({
                token,
                endpoint,
                extra: { fechaMov: `${moment(form.getFieldValue("date")).format("YYYY-MM-DD")} 09:00:00.000` },
            }),
            // action: `https://app.bodegaenlinea.cl/api/${endpoint}`,
            // headers: {
            //     Authorization: `Bearer ${token}`
            // },
            onChange(info) {
                const { file } = info
                let fl = info.fileList
                const { status } = file;

                console.log(status)

                if (status !== 'uploading') {
                    // console.log(info.file, info.fileList);
                    
                }
                if (status === 'done') {

                    const { file: fileserverpath } = info.file.response // ,homologated

                    // if (isImported || isLoaded) {
                    //     message.warning(`${info.file.name} ya ha sido ${isImported && 'importado'}${isLoaded && 'inyectado'} anteriormente. Revisa en el panel de "Importador de Documentos" en tu ERP.`);
                    //     return
                    // }

                    if (info.file.response.status === 'success') {
                        message.success(`${info.file.name} cargado exitosamente.`);
                        console.log(info.file.response)
                        setContinueDisabled(false)
                        // const _orders = form.getFieldValue('orders') ?? [];
                        form.setFieldsValue({
                            orders: [
                                {
                                    path: fileserverpath,
                                    filename: info.file.name,
                                    // detail: info.file.response.redux,
                                    // config: {
                                    //     tascam,
                                    //     correlativo,
                                    //     requireFolio,
                                    // }
                                }
                            ]
                        })
                        if (success) {
                            success(info.file)
                        }
                    } else {
                        // message.error(info.file.response.message)

                        console.log(info.file.response)
                        const args = {
                            message: 'Error al cargar',
                            description: `${info.file.response.message} Corrige el archivo y vuelvelo a cargar, nuevamente.`,
                            duration: 0
                        };
                        notification.error(args);
                        fl = fl.filter(f => f.uid !== file.uid);
                        
                        form.setFieldsValue({
                            orders: []
                        })
                    }
                } else if (status === 'error') {
                    message.error(`${info.file.name} tuvo problemas, revisa el formato e intenta nuevamente.`);

                    // const args = {
                    //     message: 'Notification Title',
                    //     description:
                    //         'I will never close automatically. This is a purposely very very long description that has many many characters and words.',
                    //     duration: 0,
                    // };
                    // notification.error(args);
                } else if (status === 'removed') {
                    form.setFieldsValue({
                        orders: []
                    })
                    fl = [];
                    setContinueDisabled(true)
                }

                setFileList(fl); 
            },
            onDrop(e) {
                console.log('Dropped files', e.dataTransfer.files);
            },
            onRemove(file) {
                const _orders = form.getFieldValue('orders') ?? [];
                form.setFieldsValue({ orders: _orders.filter((item: any) => item.path !== file.response.path) })
            },
            accept
        };
    }

    const props = createUploaderProps(token, endpoint, form, '.xlsx', (file) => {
        console.log('success from createUploaderProps ', file)
    }) // , undefined, undefined, undefined, postProcessing
    
    const customBeforeUpload = (file: any) => {
        // Detenemos el upload automático
        const newFileList = [file];
        form.setFieldsValue({ archivo: newFileList });
        return false;
    };
        

    return <Row className="WarehouseInjector--Row">
        {/* <DrawerResume data={data} modify={false} price={false} resetAll={resetAll} /> */}
        <Col span={24}>
            <Steps current={step} items={[
                { title: 'Solicitud', description: 'Detalle en Excel' },
                { title: 'Resumen', description: 'Validación y guardado' }
            ]} />

            {step === 0 && <div className="WarehouseInjector--Row--Step">
                <Row gutter={16}>
                    {!postProcessing && <Col xs={24} md={9} style={{
                        gap: 16,
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        {<Dragger {...props}>
                            <p className="ant-upload-drag-icon">
                                <FileExcelFilled />
                            </p>
                            <p className="ant-upload-text">Selecciona el archivo para inyectar</p>
                            <p className="ant-upload-hint">
                                En este primer paso, debes cargar archivos exclusivamente de <strong>{documento}</strong> para procesar en Contanet ERP. <i>Se permite un máximo de 60 lineas por documento.</i>
                            </p>
                        </Dragger>}

                        <Button icon={<FileExcelOutlined />} target='_blank' type='ghost' block size='large' href={exampleFile}>
                            Descargar <strong> Excel </strong> de ejemplo
                        </Button>
                    </Col>}
                    <Col xs={24} md={!postProcessing ? 15 : 24}>
                        <Form form={form} layout={'horizontal'} className="InjDocuments__Form" initialValues={{
                            date: moment()
                        }} onFinish={(values) => {

                            if (!postProcessing) {
                                setData(values)
                            }
                        }}>
                            {postProcessing && <>
                                <Button icon={<FileExcelOutlined />} target='_blank' type='ghost' block size='large' href={`https://app.bodegaenlinea.cl/examples/Ejemplo%20de%20Carga%20${documento}.xlsx`}>
                                    Descargar <strong> Excel </strong> de ejemplo
                                </Button>
                                <br />
                                <br />
                            </>}
                            {postProcessing && <Form.Item
                                label="Archivo"
                                name="archivo"
                                valuePropName="fileList"
                                getValueFromEvent={e => Array.isArray(e) ? e : e?.fileList}
                            >
                                <Dragger beforeUpload={customBeforeUpload} multiple={false}>
                                    <p className="ant-upload-drag-icon"><UploadOutlined /></p>
                                    <p className="ant-upload-text">Haz click o arrastra un archivo</p>
                                </Dragger>
                            </Form.Item>}
                            
                            <Form.Item name="date"
                                label="Fecha de solicitud"
                                tooltip="Elige una fecha para cursar la solicitud de consumo, esta fecha será con la cuál calcularemos el Inventario en Bodega."
                                required
                                rules={[
                                    { required: true, message: 'Debes seleccionar una fecha para la solicitud' }
                                ]}
                            >
                                <DatePicker placeholder='YYYY-MM-DD' />
                            </Form.Item>

                            <Form.List name="orders" rules={[
                                // { required: true, message: 'Necesitas cargar al menos un archivo eOC' }
                                {
                                    validator: async (_, orders) => {
                                        if (!postProcessing && (!orders || orders.length < 1)) {
                                            message.error('Necesitas cargar al menos un archivo eOC')
                                            return Promise.reject(new Error('Necesitas cargar al menos un archivo eOC'))
                                        }
                                    }, message: 'Necesitas cargar al menos un archivo eOC'
                                }
                            ]}>
                                {(fields) => (
                                    <>
                                        {fields.map((field, i) => (
                                            <Space size={0} key={`${(form.getFieldValue('orders') ?? [])[field.key]?.path}`} style={{
                                                // display: 'flex',
                                                // marginBottom: 8,
                                                // justifyContent: 'space-between',
                                                // alignItems: 'flex-start',
                                                width: '100%',
                                                marginBottom: i === fields.length - 1 ? 48 : 0
                                            }}>
                                                <Form.Item
                                                    {...field}
                                                    name={[field.name, 'path']}
                                                    hidden
                                                >
                                                    <Input />
                                                </Form.Item>
                                                <Form.Item
                                                    {...field}
                                                    name={[field.name, 'filename']}
                                                    hidden
                                                >
                                                    <Input />
                                                </Form.Item>
                                                <Form.Item
                                                    {...field}
                                                    label="Documentos"
                                                    name={[field.name, 'number']}
                                                    help={`${(form.getFieldValue('orders') ?? [])[field.key]?.filename}`}
                                                    // tooltip='El número de la eOC debe ser el mismo que el número de la eOD'
                                                    rules={[
                                                        // { pattern: /^[0-9]+$/, message: 'Para el número de la eOC, solo se permiten números' },
                                                        {
                                                            validator: (_, value) => {
                                                                const _orders = form.getFieldValue('orders') ?? [];
                                                                const _order = _orders.filter((o: any) => o.number === value)

                                                                if (_order.length > 1) {
                                                                    message.error({
                                                                        content: 'Existen eOC con el mismo número, revísalas antes de continuar.',
                                                                        key: 'order-number-duplicated',
                                                                    })
                                                                    return Promise.reject('Existen eOC con el mismo número, revísalas antes de continuar.')
                                                                }
                                                                return Promise.resolve()
                                                            }, message: 'Existen eOC con el mismo número, revísalas antes de continuar.'
                                                        }
                                                    ]}
                                                >
                                                    <Input type='hidden' />
                                                </Form.Item>
                                            </Space>
                                        ))}
                                    </>
                                )}
                            </Form.List>

                        </Form>
                    </Col>
                </Row>
            </div>}

        </Col>
    </Row>
}